import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "shorteval-result-form-component",
  ref: "wrapper"
}
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "h4 shorteval-result-label" }
const _hoisted_4 = {
  key: 0,
  class: "h2 shorteval-result-main-title"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "d-flex mb-3 d-none d-sm-none d-md-flex" }
const _hoisted_8 = { class: "me-3" }
const _hoisted_9 = {
  class: "text-muted",
  role: "button",
  tabindex: "0"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "change-vehicle-button" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "ms-2 me-1 text-decoration-underline text-muted font-sans-serif fw-500" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "fa fa-spinner fa-spin fa-5x fa-fw",
  style: {"color":"#ddd"}
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "col-lg-6 d-flex flex-column position-relative" }
const _hoisted_18 = { class: "flex-grow-2 justify-content-start align-items-center text-center mb-sm-2 mb-lg-0 result-price-title" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "result-price-wrapper" }
const _hoisted_21 = { class: "result-price d-flex flex-column justify-content-end align-items-center" }
const _hoisted_22 = ["data-price"]
const _hoisted_23 = {
  key: 1,
  id: "resultValue",
  class: "result-price-element result-price-no-available"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "text-muted equipment-features-text" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "row d-md-none mt-5 lh-1" }
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = {
  class: "text-muted",
  role: "button",
  tabindex: "0"
}
const _hoisted_32 = { class: "col-6 change-vehicle-button" }
const _hoisted_33 = { class: "text-decoration-underline text-muted font-sans-serif fw-500" }
const _hoisted_34 = { class: "mt-3 mt-md-2 mt-lg-0 mb-sm-2 mb-lg-0" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-lg-6 mb-3 mb-md-3 mb-lg-0 lh-1" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "col-lg-6 d-flex flex-grow-1 justify-content-end flex-column" }
const _hoisted_40 = { class: "evaluation-text mb-3 mb-md-2 mb-lg-3" }
const _hoisted_41 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_component = _resolveComponent("modal-component")!
  const _component_Vue3Odometer = _resolveComponent("Vue3Odometer")!
  const _component_InfoIcon = _resolveComponent("InfoIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.labels.chapterYourVehicle), 1),
      (_ctx.selectedCar.mainTypeNameWithoutYear)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.selectedCar.manufacturerName) + " " + _toDisplayString(_ctx.selectedCar.mainTypeNameWithoutYear), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("small", _hoisted_9, [
              (_ctx.icons.carFront)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.icons.carFront,
                    alt: 'View vehicle details',
                    class: "img-fluid"
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true),
              _createVNode(_component_modal_component, {
                "btn-title": _ctx.labels.viewVehicleDetails,
                title: 'Fahrzeudetails',
                body: _ctx.vehicleModalBody,
                "cancel-button-text": 'Fahrzeugdetails ändern',
                "cancel-button-class": 'btn btn-outline-secondary w-100 vehicle-detail-close-button',
                "show-cancel-button": true,
                "show-confirm-button": false,
                "class-div": 'd-inline vehicle-detail-button',
                link: 'link',
                "btn-class": 'text-decoration-underline text-muted font-sans-serif fw-500'
              }, null, 8, ["btn-title", "body"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("small", {
              class: "text-muted",
              role: "button",
              tabindex: "0",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideResultPage && _ctx.hideResultPage(...args)))
            }, [
              (_ctx.icons.pencil)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.icons.pencil,
                    alt: 'Change vehicle details',
                    class: "img-fluid"
                  }, null, 8, _hoisted_12))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.labels.changeVehicleDetails), 1)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([
              'photo position-relative',
              !_ctx.selectedCar.imageBase64Encoded ? 'd-flex justify-content-center align-items-center h-50' : ''
            ])
        }, [
          (_ctx.selectedCar.imageBase64Encoded)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "media-object img-responsive mx-auto d-block",
                alt: "car image",
                src: 'data:image/jpeg;base64,' + _ctx.selectedCar.imageBase64Encoded
              }, null, 8, _hoisted_14))
            : _createCommentVNode("", true),
          (!_ctx.selectedCar.imageBase64Encoded)
            ? (_openBlock(), _createElementBlock("i", _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.icons.expertOpinion)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: _ctx.icons.expertOpinion,
                alt: "Expert Opinion",
                class: "opinion-svg-overlay-top d-none d-lg-none d-xl-none d-xxl-none d-sm-none d-md-block"
              }, null, 8, _hoisted_16))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", {
            class: "h4 text-center",
            innerHTML: _ctx.labels.resultPageCurrentValueIndicationText
          }, null, 8, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            (_ctx.isShowed && !_ctx.noResultAvailable)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  id: "resultValue",
                  class: "result-price-element",
                  "data-price": _ctx.odometerPriceValue
                }, [
                  _createTextVNode(" € "),
                  _createVNode(_component_Vue3Odometer, {
                    class: "iOdometer",
                    value: _ctx.odometerPriceValue,
                    format: '(.ddd),dd'
                  }, null, 8, ["value", "format"]),
                  _createTextVNode(",-* ")
                ], 8, _hoisted_22))
              : _createCommentVNode("", true),
            (_ctx.isShowed && _ctx.noResultAvailable)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                  _createTextVNode(" ??? "),
                  _hoisted_24,
                  (_ctx.labels.valueCouldNotBeDetermined)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: _ctx.labels.valueCouldNotBeDetermined
                      }, null, 8, _hoisted_25))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  _hoisted_26,
                  _createElementVNode("span", _hoisted_27, [
                    _createTextVNode(" Die Erstzulassung weicht vom möglichen Bauzeitraum ab. Bitte überprüfen Sie die Erstzulassung oder wenden Sie sich an einen "),
                    _createElementVNode("a", {
                      href: _ctx.getUrlNoPrice()
                    }, "DAT-Sachverständigen", 8, _hoisted_28),
                    _createTextVNode(" vor Ort. ")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("small", _hoisted_31, [
                  _createVNode(_component_modal_component, {
                    "btn-title": _ctx.labels.viewVehicleDetails,
                    title: 'Fahrzeudetails',
                    body: _ctx.vehicleModalBody,
                    "cancel-button-text": 'Fahrzeugdetails ändern',
                    "cancel-button-class": 'btn btn-outline-secondary w-100 vehicle-detail-close-button',
                    "show-cancel-button": true,
                    "show-confirm-button": false,
                    "class-div": 'vehicle-detail-button',
                    link: 'link',
                    "btn-class": 'text-decoration-underline fw-normal text-muted font-sans-serif fw-500'
                  }, null, 8, ["btn-title", "body"])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("small", {
                  class: "text-muted fw-normal",
                  role: "button",
                  tabindex: "0",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideResultPage && _ctx.hideResultPage(...args)))
                }, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.labels.changeVehicleDetails), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_InfoIcon),
              (_ctx.settings.moreDetailsTitle)
                ? (_openBlock(), _createBlock(_component_modal_component, {
                    key: 0,
                    "class-div": 'd-inline-block',
                    "btn-title": _ctx.labels.resultPageHowIsThisValueCalculatedText,
                    title: _ctx.settings.priceCalculationTitle,
                    body: _ctx.settings.priceCalculationBody,
                    "show-cancel-button": false,
                    "show-confirm-button": false,
                    link: 'link',
                    "btn-class": 'calculated-value-question text-decoration-underline ms-1 text-muted font-sans-serif'
                  }, null, 8, ["btn-title", "title", "body"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([
                'result-price-badge',
                _ctx.isShowed && _ctx.noResultAvailable ? 'result-price-badge-without-price' : ''
              ])
          }, [
            (_ctx.icons.expertOpinion)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.icons.expertOpinion,
                  alt: "Expert Opinion",
                  class: "opinion-svg-overlay d-block d-lg-block d-xl-block d-xxl-block d-sm-block d-md-none"
                }, null, 8, _hoisted_35))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("span", {
          class: "text-muted equipment-features-text",
          innerHTML: _ctx.labels.resultPageEquipmentFeatures
        }, null, 8, _hoisted_38)
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("span", {
            innerHTML: _ctx.labels.resultPageDetaileEvaluationText
          }, null, 8, _hoisted_41)
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollToMap && _ctx.scrollToMap(...args))),
          class: _normalizeClass(['btn-primary btn w-auto mx-auto'])
        }, _toDisplayString(_ctx.labels.buttonExpertPartnerSearch), 1)
      ])
    ])
  ], 512))
}